import { useMemo } from "react";

import { useAccessControl } from "../../app/use-access-control";
import * as Permissions from "../../data/permissions";

/** Matches backend GET /access: self is always allowed; others require staff.view. */
export const useCanFetchStaffMemberAccess = (staffMemberId: string | undefined) => {
  const { profile, hasPermission } = useAccessControl();

  return useMemo(
    () =>
      Boolean(staffMemberId) &&
      (staffMemberId === profile?.id || Boolean(hasPermission?.(Permissions.STAFF_VIEW))),
    [staffMemberId, profile?.id, hasPermission]
  );
};

/** Matches backend GET /position: self is always allowed; others require staff.view_position. */
export const useCanFetchStaffPositionHistory = (staffMemberId: string | undefined) => {
  const { profile, hasPermission } = useAccessControl();

  return useMemo(
    () =>
      Boolean(staffMemberId) &&
      (staffMemberId === profile?.id || Boolean(hasPermission?.(Permissions.STAFF_VIEW_POSITION))),
    [staffMemberId, profile?.id, hasPermission]
  );
};
